module.exports = __webpack_public_path__ + "media/honey-icons/icon-push-notifications-a57aec57.svg";